module.exports = __webpack_public_path__ + "img/button-gmail.7ece9bd3.png";